/* global graphql */

import React from 'react';
import Features from '../components/features';
import SectionContainer from '../components/section-container';
import SectionPortfolio from '../components/section-portfolio';
import SectionQuestions from '../components/section-questions';
import SectionCta from '../components/section-cta';
import '../static/css/css/all.css'


const IndexPage = (props) => {
	//console.log('props en es', props);
	return (
		<main id="main-content">
	    	<Features data={props.data.allDataJson.edges[0].node.es[1]} />
			<SectionContainer data={props.data.allDataJson.edges[0].node.es[2]} />
			<SectionPortfolio data={props.data.allDataJson.edges[0].node.es[3]} />
			<SectionQuestions data={props.data.allDataJson.edges[0].node.es[4]}  datab={props.data.allDataJson.edges[0].node.es[5]}/>
			<SectionCta data={props.data.allDataJson.edges[0].node.es[6]}/>
		</main> )
};

export default IndexPage;

export const pageQuery = graphql`
  query IndexQueryEs {
    allDataJson {
    edges {
      node {
        es {
          title
          ctabutton
          parts {
            content
            title
            image
            link 
            social
            id
            description
          } 
        } 
      }
    }
  }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.es.js